<template>
    <div class="index-page">
        <div class="content">
            <!-- Notícias -->
            <title-header title="Notícias" />
            <div class="news-area grid grid-cols-1">
                <div class="mb-5">
                    <carousel
                        :perPage="1"
                        :autoplayHoverPause="true"
                        :paginationPadding="5"
                        :perPageCustom="[[200, 1]]"
                    >
                        <slide
                            v-for="(manchete, index) in manchetes"
                            :key="index"
                        >
                            <article
                                class="primary-article"
                                v-if="manchete.id !== undefined"
                            >
                                <figure>
                                    <a
                                        :href="
                                            'noticias/noticia/' + manchete.id
                                        "
                                    >
                                        <div class="img">
                                            <img
                                                :src="
                                                    getFirstActveImage(
                                                        manchete.imagens
                                                    )
                                                "
                                                alt="Imagem Manchete"
                                            />
                                        </div>
                                    </a>
                                    <figcaption>
                                        <article-header
                                            category="Manchete"
                                            :date="manchete.data_noticia"
                                        />
                                        <h3 class="title">
                                            {{ manchete.titulo }}
                                        </h3>
                                        <p
                                            class="main-article-text"
                                            v-html="
                                                manchete.noticia.substring(
                                                    0,
                                                    300
                                                )
                                            "
                                            v-if="manchete.noticia.length > 0"
                                        ></p>
                                        <a
                                            :href="
                                                'noticias/noticia/' +
                                                    manchete.id
                                            "
                                            class="leia-mais"
                                        >
                                            ...Leia mais
                                        </a>
                                    </figcaption>
                                </figure>
                            </article>
                        </slide>
                    </carousel>
                </div>
                <div>
                    <div
                        class="secondary-articles-area"
                        v-bind:class="{ onlyNews: manchete.id === undefined }"
                    >
                        <a
                            v-for="(noticia, index) in noticias"
                            :key="index"
                            :href="'noticias/noticia/' + noticia.id"
                        >
                            <secondary-articles
                                :category="stringCategoria(noticia.id)"
                                :text="noticia.noticia"
                                :date="noticia.data_noticia"
                                :img="noticia.imagens"
                            />
                        </a>
                    </div>
                </div>
            </div>

            <!-- Institucional -->
            <title-header title="Institucional" />
            <institutional-area :maisNoticias="maisNoticias" />

            <!-- Newsletter -->
            <title-header title="Fique por Dentro" class="text__margem" />
            <newsletter />

            <!-- Videos -->
            <title-header title="Vídeos" class="mt-8" />
            <video-container />
        </div>
    </div>
</template>

<script>
import TitleHeader from "./components/title-header";
import SecondaryArticles from "./components/secondary-articles";
import Tag from "./components/tag";
import VideoContainer from "./components/video-container";
import ArticleHeader from "./components/article-header";
import InstitutionalArea from "./components/institucional";
import Newsletter from "./components/newsletter";

import axios from "axios";
import Images from "../../../mixins/images.mixin";

export default {
    name: "news-area",
    components: {
        Newsletter,
        InstitutionalArea,
        ArticleHeader,
        TitleHeader,
        Tag,
        SecondaryArticles,
        VideoContainer
    },

    mixins: [Images],
    data() {
        return {
            noticias: [],
            maisNoticias: [],
            manchetes: {},
            manchete: {}
        };
    },
    created() {
        this.buscarNoticia();
    },

    methods: {
        async buscarNoticia() {
            let response = await axios.get("get-noticias-index");
            if (response.status === 200) {
                this.manchetes = response.data.manchete;
                this.noticias = response.data.noticia.slice(0, 3);
                this.maisNoticias = response.data.noticia.slice(3, 6);
            }
        },

        stringCategoria(id) {
            switch (id) {
                case "1":
                    return "UGT Notícias";
                    break;
                case "2":
                    return "Palavra do Presidente";
                    break;
                case "3":
                    return "Comentário do Diretor";
                    break;
                default:
                    return "UGT Notícias";
            }
        }
    }
};
</script>
<style>
.VueCarousel-dot-container {
    margin: 0 !important;
}
</style>
<style scoped lang="scss">
.index-page {
    @apply p-4;

    @screen md {
        @apply p-8;
    }
    a {
        @apply text-black;
    }

    .content {
        @apply mx-auto;
        max-width: 1280px;

        .leia-mais {
            @apply text-black italic font-black;

            &:hover {
                @apply text-secondary;
            }
        }

        .news-area {
            @media (max-width: 879px) {
                @apply mx-auto w-full;
                max-width: 640px;
                .primary-article {
                    @apply w-full;
                    img {
                        width: 100%;
                        min-height: 250px;
                        background-color: #fed843;
                        border-radius: 10px;
                    }
                    .main-article-text {
                        @apply text-base text-justify;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 5;
                        -webkit-box-orient: vertical;
                    }
                }
            }
            @media (min-width: 880px) {
                @apply grid-cols-2 w-full mx-auto;
                .primary-article {
                    @apply pr-10 border-r-2 border-light-gray col-span-1;
                    img {
                        width: 100%;
                        max-height: 350px;
                        object-fit: cover;
                        object-position: top;
                        background-color: #fed843;
                        border-radius: 10px;
                    }
                    h3 {
                        @apply text-3xl;
                    }
                    .main-article-text {
                        @apply text-base text-justify;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 5;
                        -webkit-box-orient: vertical;
                    }
                }
                .secondary-articles-area {
                    @apply col-span-1;
                    a {
                        @apply border-b-2 border-light-gray pb-5 pt-5;
                    }
                    a:first-child {
                        @apply pt-0;
                    }
                    a:last-child {
                        @apply pb-0 border-b-0;
                    }
                }
                .secondary-articles-area.onlyNews {
                    @apply col-span-2;
                }
            }
            .secondary-articles-area {
                @apply flex flex-col justify-between w-full;
                @media (min-width: 880px) {
                    @apply pl-10;
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .text__margem {
        @apply mt-8;
    }
}
</style>
